import { Play, CheckCircle2, Clock } from "lucide-react";
import { mediaUrl, fmtDuration } from "@/lib/academy";

export const LessonCard = ({ lesson, index, onOpen }) => (
  <button
    type="button"
    onClick={() => onOpen(lesson)}
    className="group text-left rounded-2xl border border-border bg-card overflow-hidden transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-primary/50 hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-primary animate-in fade-in slide-in-from-bottom-2"
    style={{ animationDelay: `${index * 60}ms`, animationFillMode: "both" }}
    data-testid={`academy-lesson-card-${lesson.id}`}
  >
    <div className="relative aspect-video bg-muted overflow-hidden">
      {lesson.thumbnail_url && <img src={mediaUrl(lesson.thumbnail_url)} alt="" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="w-12 h-12 rounded-full bg-white/90 text-slate-900 flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110" data-testid={`academy-lesson-play-${lesson.id}`}>
          <Play className="w-5 h-5 ml-0.5 fill-current" />
        </span>
      </span>
      <span className="absolute bottom-2 left-2 text-[11px] font-medium rounded-full bg-black/60 text-white px-2 py-0.5 flex items-center gap-1"><Clock className="w-3 h-3" />{fmtDuration(lesson.duration)}</span>
      {!lesson.video_url && <span className="absolute top-2 left-2 text-[11px] font-semibold rounded-full bg-amber-500 text-slate-900 px-2 py-0.5" data-testid={`academy-coming-soon-${lesson.id}`}>Video coming soon</span>}
      {lesson.completed && <span className="absolute top-2 right-2 rounded-full bg-emerald-500 text-white p-1 shadow" data-testid={`academy-lesson-done-${lesson.id}`}><CheckCircle2 className="w-4 h-4" /></span>}
    </div>
    <div className="p-4 space-y-1.5">
      <div className="text-[11px] font-mono uppercase tracking-widest text-primary">{lesson.category}</div>
      <div className="font-heading font-semibold leading-snug">{lesson.title}</div>
      <p className="text-sm text-muted-foreground line-clamp-2">{lesson.description}</p>
    </div>
  </button>
);
